import React from "react";
import styled from "styled-components";

import book1 from "../images/home/booksImg1.png";
import book1b from "../images/home/booksImg2.png";

import book2 from "../images/home/booksImg3.png";
import book2b from "../images/home/booksImg4.png";

import book3 from "../images/home/booksImg5.png";
import book3b from "../images/home/booksImg6.png";

import book4 from "../images/home/booksImg7.png";
import book4b from "../images/home/booksImg8.png";

const ColoringBooks = () => {
  const products = [
    {
      title: "A Garland of Grace Coloring Book - Proverbs",
      img1: book1,
      img2: book1b,
      rating: 4.5,
      reviews: 5,
      price: "$9.99 USD",
    },
    {
      title: "Surprised by Joy Coloring Book",
      img1: book2,
      img2: book2b,
      rating: 4.5,
      reviews: 6,
      price: "$9.99 USD",
    },
    {
      title: "The Names of Jesus Prompted Coloring...",
      img1: book3,
      img2: book3b,
      rating: 4.5,
      reviews: 5,
      price: "$9.99 USD",
    },
    {
      title: "Color the Promises of God Coloring Book",
      img1: book4,
      img2: book4b,
      rating: 4,
      reviews: 4,
      price: "$9.99 USD",
    },
  ];

  return (
    <Section>
      <Heading>Shop Christian Coloring Books</Heading>

      <Grid>
        {products.map((item, i) => (
          <Card key={i}>
            <ImageWrapper>
              <MainImage src={item.img1} />
              <HoverImage src={item.img2} />
            </ImageWrapper>

            <Title>{item.title}</Title>

            <Rating>
              ★★★★☆
              <span>({item.reviews})</span>
            </Rating>

            <Price>{item.price}</Price>
          </Card>
        ))}
      </Grid>

      <ViewAllButton>View all</ViewAllButton>
    </Section>
  );
};

export default ColoringBooks;

const Section = styled.section`
  background: #f4ebe3;
  padding: 50px 70px;
  text-align: center;
`;

const Heading = styled.h2`
  font-size: 28px;
  color: #3b4b48;
  margin-bottom: 40px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 35px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0,0,0,0.08);
`;

const Title = styled.p`
  margin-top: 16px;
  font-size: 12px;
  color: #3b4b48;
  padding: 0 10px;
`;

const Rating = styled.div`
  margin-top: 8px;
  font-size: 16px;
  color: #ffb400;

  span {
    color: #444;
    font-size: 16px;
    margin-left: 6px;
  }
`;

const Price = styled.div`
  margin-top: 10px;
  font-size: 16px;
  color: #cc0000;
  font-weight: bold;
  padding-bottom: 20px; 
`;

const ViewAllButton = styled.button`
  margin-top: 50px;
  padding: 14px 40px;
  background: #3b4b48;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    opacity: 0.85;
  }
`;



const ImageWrapper = styled.div`
  background: white;
  position: relative;
  margin:auto;
  width: 90%;
  height:250px;
  overflow: hidden;
  border-radius: 16px;

  &:hover img:first-child {
    opacity: 0;
  }

  &:hover img:last-child {
    opacity: 1;
  }
`;

const MainImage = styled.img`
margin-top:10px;
  width: 100%;
 height: 100%;       /* FILL HEIGHT */
  object-fit: cover;
  border-radius: 16px;
  position: absolute;
  left: 0;
  top: 0;
  transition: 0.3s ease;
  opacity: 1;
`;

const HoverImage = styled.img`
margin-top:10px;
  width: 100%;
  height: 100%;       /* FILL HEIGHT */
  object-fit: cover;
  border-radius: 16px;
  position: relative;
  transition: 0.3s ease;
  opacity: 0;
`;
